import { render, staticRenderFns } from "./EvolveMessageCenter.vue?vue&type=template&id=edb0c5d8&scoped=true&"
import script from "./EvolveMessageCenter.vue?vue&type=script&lang=js&"
export * from "./EvolveMessageCenter.vue?vue&type=script&lang=js&"
import style0 from "./EvolveMessageCenter.vue?vue&type=style&index=0&id=edb0c5d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb0c5d8",
  null
  
)

export default component.exports